import { render } from "./AgeBarChart.vue?vue&type=template&id=05a872ac"
import script from "./AgeBarChart.vue?vue&type=script&lang=js"
export * from "./AgeBarChart.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/AgeBarChart.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "05a872ac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('05a872ac', __exports__)) {
    api.reload('05a872ac', __exports__)
  }
  
  module.hot.accept("./AgeBarChart.vue?vue&type=template&id=05a872ac", () => {
    api.rerender('05a872ac', render)
  })

}


export default __exports__